import React from "react";
import { Loader } from "rsuite";
import { SkeletonTableProps } from "./types";
import { TableColumn } from "components/Table/RenderColumns";
import { SkeletonRow, SkeletonCell } from "./SkeletonStyles";


export const SkeletonTable: React.FC<SkeletonTableProps> = ({
    rows = 5,
    columns = [],
    rowHeight = 46,
    headerHeight = 46
}) => {
    const middleRowIndex = Math.floor(rows / 2);

    return (<div>
        {Array.from({ length: rows }).map((_, rowIdx) => {
            if (rowIdx === middleRowIndex) {
                return (
                    <SkeletonRow
                        key={`loader-${rowIdx}`}
                        headerHeight={headerHeight}
                        rowHeight={rowHeight}
                    >
                        <SkeletonCell
                            key="loader-cell"
                            width={0}
                            flexGrow={columns.length}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <Loader size="md" content="" />
                        </SkeletonCell>
                    </SkeletonRow>
                );
            }


            return (<SkeletonRow key={rowIdx} headerHeight={headerHeight} rowHeight={rowHeight}>
                {columns.map((column: TableColumn, colIdx) => {
                    // column.width і column.minWidth мають тип ResponsiveValue<number>
                    const raw = column.width ?? column.minWidth;

                    // Якщо це число — беремо одразу, якщо масив/обʼєкт — дістаємо перше число
                    const columnWidth: number =
                        typeof raw === "number"
                            ? raw
                            : Array.isArray(raw)
                                ? raw[0]
                                : typeof raw === "object"
                                    ? Number(Object.values(raw)[0])
                                    : Number(raw);

                    const flexGrow = column.flexGrow;

                    return (<SkeletonCell
                        key={colIdx}
                        width={columnWidth}
                        flexGrow={flexGrow}
                    />);
                })}
            </SkeletonRow>);
        })}
    </div>);
};
